export const AUTH_STORAGE_KEY = "maeiz-rider-auth";

export const APP_ROLE = "rider" as const;

export type AppRole = typeof APP_ROLE;
